import React, { useState } from "react";
import { Dropdown, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/pro-light-svg-icons";
import ExcelImage from "../../styles/file-spreadsheet.png";
import * as fileSaver from "file-saver";
// import axios from "axios";
// import { apiDetails } from "../../services/helpers";
import {
  getDownloadInputFileReport,
  getSubmittedFilebyFileId,
  getInputFileById,
} from "../../services";

const ExcelDropDown = ({
  submittedFile,
  submittedFileExcel,
  inputFile,
  inputFileExcel,
  header,
  fileName,
  fileId,
  fileType,
}) => {
  const [expand, setExpand] = useState(false);
  var extension =
    fileName?.split(".")[fileName?.split(".").length - 1] == "csv"
      ? "csv"
      : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  const onExpand = () => {
    setExpand(!expand);
  };

  const exportInputFile = () => {
    getInputFileById(fileId)
      .then((response) => {
        var blob = new Blob([response], {
          type: extension,
        });
        fileSaver.saveAs(blob, fileName);
      })
      .catch((error) => {});
    setExpand(false);
  };

  const exportSubmittedFile = () => {
    getSubmittedFilebyFileId(fileId)
      .then((response) => {
        var blob = new Blob([response], {
          type: extension,
        });
        const filename =
          fileName?.split(".")[fileName?.split(".").length - 1] == "xls"
            ? "SubmittedFile_" + fileName?.split(".")[0] + ".xlsx"
            : "SubmittedFile_" + fileName;
        fileSaver.saveAs(blob, filename);
      })
      .catch((error) => {});
    setExpand(false);
  };

  // function exportInputFile() {
  //   axios.get(apiDetails.baseUrl.trim() + '/api/v1/Report/DownloadInputFile/1', { responseType: 'arraybuffer' })
  //     .then((response) => {
  //       var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       fileSaver.saveAs(blob, 'InputFile.xlsx');
  //     });
  // }

  // function exportSubmittedFile() {
  //   axios.get(apiDetails.baseUrl.trim() + '/api/v1/Report/DownloadSubmittedFile/1', { responseType: 'arraybuffer' })
  //     .then((response) => {
  //       var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       fileSaver.saveAs(blob, 'SubmittedFile.xlsx');
  //     });
  // }
  return (
    <div className="d-flex flex-row excel-button-container">
      <div className="dropdown-excel-button">
        <Image
          src={ExcelImage}
          width="20px"
          style={{ cursor: "pointer" }}
          onClick={() => fileType == 4 && exportInputFile()}
        />
      </div>
      {fileType != 4 && (
        <Dropdown className="d-flex align-items-end">
          <Dropdown.Toggle className="arrow-icon-drop">
            <FontAwesomeIcon icon={faAngleDown} size="lg" />
          </Dropdown.Toggle>
          <Dropdown.Menu className="dropdown-excel">
            <Dropdown.Header className="text-black">
              Download File
            </Dropdown.Header>
            <Dropdown.Divider />
            <Dropdown.Item onClick={exportSubmittedFile}>
              {submittedFile}
            </Dropdown.Item>
            <Dropdown.Item onClick={exportInputFile}>{inputFile}</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

export default ExcelDropDown;
